import { Sound as CommonSound } from "common/sound";
import * as R from "ramda";
export const fileName = "사운드 소스.m4a";
export async function loadSound(src) {
    try {
        return await CommonSound.load({
            sheetPath: src,
            sprite: spriteForHowler,
            loopNameMapper,
        });
    }
    catch (e) {
        console.error(e);
        throw e;
    }
}
const loopNameMapper = (loopName) => {
    switch (loopName) {
        case "background":
            return ["background"];
        case "heartbeat":
            return ["heartbeat"];
    }
};
export function speakingName(id) {
    if (id < 1 || id > 6) {
        throw new Error(`Invalid speaking number ${id}`);
    }
    return `speaking${id}`;
}
const sprite = {
    opening: [0 + 4 / 30, 3 + 13 / 30],
    background: [3 + 15 / 30, 9 + 21 / 30],
    heartbeat: [9 + 27 / 30, 10 + 23 / 30],
    speaking0: [10 + 23 / 30, 13 + 0 / 30],
    speaking1: [13 + 5 / 30, 15 + 17 / 30],
    speaking2: [15 + 24 / 30, 18 + 17 / 30],
    speaking3: [18 + 18 / 30, 21 + 11 / 30],
    speaking4: [21 + 23 / 30, 24 + 28 / 30],
    speaking5: [25 + 1 / 30, 30 + 4 / 30],
};
export const spritesDurations = R.map(([start, end]) => end * 1000 - start * 1000, sprite);
const spriteForHowler = R.map(([start, end]) => [
    Math.floor(start * 1000),
    Math.floor(end * 1000 - start * 1000),
], sprite);
//# sourceMappingURL=sound.js.map